import { render, staticRenderFns } from "./CalendarMonth.vue?vue&type=template&id=474be753&scoped=true&"
import script from "./CalendarMonth.vue?vue&type=script&lang=js&"
export * from "./CalendarMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474be753",
  null
  
)

export default component.exports